import UserPermissionsDetails from './userPermissionsDetails';

export default UserPermissionsDetails;
